export default __webpack_public_path__ + "static/media/infoIllustration8.8a7d45a9.gif";